import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { ValidarLogin } from './util';
import { logOut } from './actions';
import './App.scss';
import Emisor from './components/emisor/Emisor';
import Facturas from './components/factura/Facturas';
import Sidebar from './components/sidebar/SideBar';
import Login from './components/login/Login';
import Inventario from './components/inventario/Inventario';
import CrearFactura from './components/factura/CrearFactura';
import ImprimirDocumento from './components/imprimirDocumento/ImprimirDocumento';
import CrearNotaCredito from './components/NotaCredito/CrearNotaCredito';
import CrearNotaDebito from './components/NotaDebito/CrearNotaDebito';
import NotasDebito from './components/NotaDebito/NotasDebito';
import NotasCredito from './components/NotaCredito/NotasCredito';
import ConfirmarFacturas from './components/confirmarFacturas/ConfirmarFacturas'
import Tiquetes from './components/tiquete/Tiquetes';
import CrearTiquete from './components/tiquete/CrearTiquete';
import Reportes from './components/reportes/Reportes';
import Dashboard from './components/dashboard/Dashboard';
import Logout from './components/login/Logout';
import CrearFaturaCompra from './components/factura/crearFaturaCompra';
import facturasCompras from './components/factura/facturasCompras';
import FactuasConfirmadas from './components/confirmarFacturas/FacturasConfirmadas';


function App(props) {
  const { token } = ValidarLogin(props);

  useEffect(() => {
    if (token === null) {
      props.logOut();
    }
  }, [token]);

  const enableLoading = () => {
    return props.isLoading ? 'ui active inverted dimmer' : 'ui disabled inverted dimmer';
  };

  return (
    <>
      <BrowserRouter>
        <Sidebar />
        <Switch>
          <>
            <div className="ui container app" >
              <div className={enableLoading()}>
                <div className="ui text loader">Espere por favor...</div>
              </div>
              <Route path="/" exact component={Dashboard} />
              <Route path="/login" exact component={Login} />
              <Route path="/logout" exact component={Logout} />
              <Route path="/emisor" axact component={Emisor} />
              <Route path="/productos" axact component={Inventario} />

              <Route path="/facturas" axact component={Facturas} />
              <Route path="/crearfactura" axact component={CrearFactura} />

              <Route path="/facturasCompras" axact component={facturasCompras} />
              <Route path="/crearFaturaCompra" axact component={CrearFaturaCompra} />

              <Route path="/notascredito" axact component={NotasCredito} />
              <Route path="/crearnotacredito" axact component={CrearNotaCredito} />

              <Route path="/notasdebito" axact component={NotasDebito} />
              <Route path="/crearnotadebito" axact component={CrearNotaDebito} />

              <Route path="/tiquetes" axact component={Tiquetes} />
              <Route path="/creartiquete" axact component={CrearTiquete} />

              <Route path="/imprimirdocumento/:tipo?" component={ImprimirDocumento} />
              <Route path="/confirmacionfacturas" axact component={ConfirmarFacturas} />
              <Route path="/listarconfirmadas" axact component={FactuasConfirmadas} />

              <Route path="/reportes" axact component={Reportes} />

            </div>
          </>
        </Switch>
      </BrowserRouter>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    loginState: state.loginState,
    isLoading: state.isLoadingState,
  };
}

export default connect(mapStateToProps, { logOut })(App);